import {connect} from 'react-redux';
import FeeList from './FeeList.jsx';
import {displayDeactivateModal} from './actionTypes';

const mapStateToProps = state => ({
  source: state.tournament.fees.activeFees
});

const mapDispatchToProps = dispatch => ({
  onFeeItemSwitchClick: feeItem => dispatch(displayDeactivateModal(feeItem))
});

export default connect(mapStateToProps, mapDispatchToProps)(FeeList);



// WEBPACK FOOTER //
// ./src/features/tournament/fees/FeeListActiveContainer.jsx